var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"d-flex flex-column align-md-start",style:(_vm.white ? 'background-color: transparent' : ''),attrs:{"dense":"","rounded":""}},_vm._l((_vm.contacts),function(ref,i){
var link = ref.link;
var icon = ref.icon;
var text = ref.text;
return _c('v-list-item',{key:i,attrs:{"href":link,"target":"_blank"}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":_vm.white ? 'white' : ''}},[_vm._v(_vm._s(icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',{class:_vm.white ? 'white--text' : ''},[_vm._v(" "+_vm._s(text)+" ")])],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }